import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DialogContentText } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { capitalise } from '../../util/string';

const useStyles = makeStyles(theme => ({
  dependencyItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  dependencyLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: 10,
  },
  dependencyLink: {
    fontSize: 16,
  },
}));

/**
 * Reusable component for displaying entity dependencies
 * @param {Object} props - Component props
 * @param {Object} props.dependencyStructure - Object containing dependency data
 * @param {string} props.type - Type of the parent entity
 * @param {string|number} props.entityId - ID of the parent entity
 * @param {Function} props.onClose - Function to call when closing
 * @param {boolean} props.showDescription - Whether to show the description text
 */
const DependencyDisplay = ({
  dependencyStructure,
  type,
  entityId,
  onClose,
  showDescription = true,
  refetchData,
  refetchCount,
}) => {
  const classes = useStyles();

  const handleNavigate = item => {
    if (refetchData) refetchData();
    if (refetchCount) refetchCount();

    onClose();
  };

  return (
    <>
      {showDescription && <DialogContentText>This {type} is referenced by the following entities:</DialogContentText>}
      {Object.keys(dependencyStructure).map((item, index) => (
        <div key={`dependency_${index}`} className={classes.dependencyItem}>
          <span className={classes.dependencyLabel}>{capitalise(item)}</span>
          <Link
            className={classes.dependencyLink}
            onClick={() => handleNavigate(item)}
            to={{
              pathname: '/delete',
              state: {
                records: dependencyStructure[item],
                entityType: item,
                parentType: type,
                parentId: entityId,
                // No refetch functions in state - they're executed before navigation
              },
            }}>
            Go to {capitalise(item)}
          </Link>
        </div>
      ))}
    </>
  );
};

export { DependencyDisplay };
